import { isUsableProfilePhotoUrl } from '../platform/chatAuthorColors';

export function resolvePhotoCandidate(photoURL) {
  const value = String(photoURL || '').trim();
  if (!value) {
    return '';
  }
  if (value.startsWith('blob:')) {
    return value;
  }
  return isUsableProfilePhotoUrl(value) ? value : '';
}
